<template lang="pug">
.ovg-create-view

  //- Header
  .header-ovg.d-none.d-md-flex
    .title-section(@click="$router.push('/garantias-center')")
      b-icon.back-arrow(icon="arrow-left-square-fill")
      h4.title Creación OVG

  .breadcrumbs-ovg
    span.text-muted Inicio / Oportunidades de Venta / Garantías Extendidas OVG /&nbsp;
    span.text-dark Creación OVG

  .container-create
    .create-layout
      //- Columna izquierda: Wizard
      .wizard-column
        //- ─── PASO 1: Datos del Cliente ────────────────────────────────────────
        .step-card
          .step-header(@click="irAPaso(1)" :class="{ active: pasoActivo === 1 }")
            .step-number(:class="{ done: pasoMaxAlcanzado > 1 }")
              b-icon(v-if="pasoMaxAlcanzado > 1" icon="check-lg")
              span(v-else) 1
            .step-label Datos del Cliente
            b-icon.step-toggle(:icon="pasoActivo === 1 ? 'chevron-up' : 'chevron-down'")
          .step-body(v-show="pasoActivo === 1")
            b-row
              b-col(cols="12")
                b-form-group(label="RUT*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.rut"
                    placeholder="12345678-9"
                    :state="fieldState('rut')"
                  )
                  b-form-invalid-feedback {{ errors.rut }}
            b-row
              b-col(cols="12" md="6")
                b-form-group(label="Nombre*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.nombre"
                    :state="fieldState('nombre')"
                  )
                  b-form-invalid-feedback {{ errors.nombre }}
              b-col(cols="12" md="6")
                b-form-group(label="Apellido*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.apellido"
                    :state="fieldState('apellido')"
                  )
                  b-form-invalid-feedback {{ errors.apellido }}
            b-row
              b-col(cols="12" md="6")
                b-form-group(label="Correo Electrónico*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.correo"
                    type="email"
                    placeholder="ej:correo@mail.cl"
                    :state="fieldState('correo')"
                  )
                  b-form-invalid-feedback {{ errors.correo }}
              b-col(cols="12" md="6")
                b-form-group(label="Teléfono (Opcional)" label-class="samtek-label")
                  b-form-input(
                    v-model="form.telefono"
                  )
            .d-flex.justify-content-end.mt-3
              b-button.btn-step-primary(@click="avanzarPaso1") Siguiente Paso

        //- ─── PASO 2: Modelo de Equipo ──────────────────────────────────────────
        .step-card
          .step-header(@click="pasoMaxAlcanzado >= 2 && irAPaso(2)" :class="{ active: pasoActivo === 2, locked: pasoMaxAlcanzado < 2 }")
            .step-number(:class="{ done: pasoMaxAlcanzado > 2 }")
              b-icon(v-if="pasoMaxAlcanzado > 2" icon="check-lg")
              span(v-else) 2
            .step-label Modelo de Equipo
            b-icon.step-toggle(:icon="pasoActivo === 2 ? 'chevron-up' : 'chevron-down'" v-if="pasoMaxAlcanzado >= 2")
          .step-body(v-show="pasoActivo === 2")
            h5.seccion-subtitulo Datos Generales
            .modelo-grupo
              label.samtek-label Modelo del Equipo*
              .modelo-search-row
                b-form-input(
                  v-model="modeloQuery"
                  placeholder="Buscar modelo ..."
                  @input="onModeloSearch"
                  :disabled="modeloNuevo"
                )
                b-button.btn-crear-modelo(variant="outline-secondary" @click="activarModeloNuevo" v-if="!modeloNuevo && !modeloSeleccionado") Crear Nuevo Modelo
                b-spinner.ml-2(v-if="loadingModelos" small variant="secondary")
              .modelo-resultados(v-if="modeloResultados.length && !modeloNuevo")
                .modelo-item(
                  v-for="m in modeloResultados"
                  :key="m.id"
                  @click="seleccionarModelo(m)"
                  :class="{ selected: form.modelo_id === m.id }"
                ) {{ m.nombre || m.id }}
              .modelo-seleccionado(v-if="modeloSeleccionado && !modeloNuevo")
                b-badge(variant="primary" pill)
                  | {{ modeloSeleccionado.nombre || modeloSeleccionado.id }}
                  b-icon.ml-1(icon="x" @click="limpiarModelo" style="cursor:pointer")
              .modelo-seleccionado(v-if="modeloNuevo && form.modelo_nuevo_nombre")
                b-badge(variant="info" pill)
                  | {{ form.modelo_nuevo_nombre }}
                  b-icon.ml-1(icon="x" @click="cancelarModeloNuevo" style="cursor:pointer")
              .text-muted.small.mt-1(v-if="modeloQuery.length >= 2 && !loadingModelos && !modeloResultados.length && !modeloNuevo && !modeloSeleccionado")
                | No se encontraron modelos.
              .text-danger.small.mt-1(v-if="errors.modelo_id") {{ errors.modelo_id }}

            .fecha-compra-grupo.mt-3
              label.samtek-label Fecha de Compra*
              b-form-datepicker(
                v-model="form.fecha_compra_equipo"
                locale="es-CL"
                :max="hoy"
                :state="fieldState('fecha_compra_equipo')"
                placeholder="Selecciona"
                @input="onFechaCompraChange"
              )
              b-form-invalid-feedback {{ errors.fecha_compra_equipo }}
              .text-muted.small.mt-1(v-if="form.fecha_compra_equipo && !equipoReciente")
                b-icon(icon="info-circle")
                |  El equipo tiene más de 180 días — no aplican protecciones adicionales.

            .boleta-upload-group.mt-3
              label.samtek-label.d-block.mb-2 Boleta*
              input(
                ref="boletaInput"
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                style="display:none"
                @change="onBoletaChange"
              )
              .boleta-dropzone(
                @dragover.prevent="boletaDragOver = true"
                @dragleave="boletaDragOver = false"
                @drop.prevent="onBoletaDrop"
                :class="{ 'is-dragover': boletaDragOver }"
              )
                template(v-if="!boletaFile")
                  b-icon.boleta-upload-icon(icon="cloud-upload" font-scale="2.5")
                  p.boleta-upload-text.mb-2 Arrastra y suelta tu archivo aquí.
                  b-button.btn-seleccionar-boleta(@click="$refs.boletaInput.click()") Seleccionar desde tu equipo
                  small.text-muted.mt-2.d-block Formatos aceptados: JPG, PNG o PDF. Peso máximo: 5 MB.
                template(v-else-if="boletaEsImagen")
                  img.boleta-img-preview(:src="boletaPreviewUrl" alt="Boleta")
                  b-button.btn-cambiar-boleta.mt-2(variant="link" size="sm" @click="$refs.boletaInput.click()")
                    b-icon(icon="pencil")
                    |  Cambiar imagen
                template(v-else)
                  b-icon(icon="file-earmark-pdf-fill" variant="danger" font-scale="3")
                  p.mt-2.mb-1.font-weight-600 {{ boletaFile.name }}
                  b-button.btn-cambiar-boleta.mt-1(variant="link" size="sm" @click="$refs.boletaInput.click()")
                    b-icon(icon="pencil")
                    |  Cambiar archivo
              .text-danger.small.mt-1(v-if="errors.boleta_cliente") {{ errors.boleta_cliente }}

            .detalle-equipos-grupo.mt-4
              h5.seccion-subtitulo Detalle de Equipos a Registrar

              //- Modo Excel cargado (SILL-1587 / SILL-1577)
              .excel-cargado-box.mb-3(v-if="excelCargado")
                .d-flex.align-items-center.justify-content-between.p-3.border.rounded.bg-light
                  .d-flex.align-items-center
                    b-icon(icon="file-earmark-excel-fill" variant="success" font-scale="2" class="mr-3")
                    div
                      .font-weight-bold.text-success Excel cargado correctamente
                      .small.text-muted {{ archivoExcel ? archivoExcel.name : 'Series Excel' }} ({{ seriesExcel.length }} series)
                  .d-flex.align-items-center
                    b-button.mr-2(size="sm" variant="outline-primary" @click="abrirModalExcel") Reemplazar
                    b-button(size="sm" variant="outline-danger" @click="quitarExcel") Quitar Excel

              .serie-fila(v-for="(s, index) in form.numeros_serie" :key="index")
                label.samtek-label N° de Serie Equipo {{ index + 1 }}*
                .d-flex.align-items-center.serie-input-box
                  b-form-input.serie-input-field(
                    v-model="form.numeros_serie[index]"
                    placeholder="S/N 123456789"
                    :state="errorSerie(index)"
                    maxlength="15"
                    :disabled="excelCargado"
                  )
                  b-button.btn-eliminar-serie-icon(
                    v-if="form.numeros_serie.length > 1 && !excelCargado"
                    variant="link"
                    @click="removerSerie(index)"
                    title="Eliminar número de serie"
                  )
                    b-icon(icon="trash-fill" variant="danger")
                .text-danger.small.mt-1(v-if="errors[`serie_${index}`]") {{ errors[`serie_${index}`] }}

              b-button.btn-add-serie-mockup.mt-2(
                v-if="!excelCargado"
                variant="link"
                @click="agregarSerie"
              )
                b-icon(icon="plus-square-fill" class="mr-1")
                |  Agregar otro número de Serie
              b-form-invalid-feedback(v-if="errors.numero_serie" style="display:block") {{ errors.numero_serie }}

              //- Botón Subir Excel con Series (mockup SILL-1577)
              .mt-3(v-if="!excelCargado")
                p.text-muted.small.mb-2 Si son muchos, te recomendamos subir un Excel con los números de serie.
                b-button.btn-subir-excel-series(
                  variant="outline-primary"
                  @click="abrirModalExcel"
                )
                  b-icon(icon="file-earmark-spreadsheet" class="mr-2")
                  | Subir Excel con Series

            .d-flex.justify-content-end.mt-4
              b-button.btn-step-primary(@click="avanzarPaso2") Siguiente Paso


        //- ─── PASO 3: Extensión de Garantía ─────────────────────────────────────
        .step-card
          .step-header(@click="pasoMaxAlcanzado >= 3 && irAPaso(3)" :class="{ active: pasoActivo === 3, locked: pasoMaxAlcanzado < 3 }")
            .step-number(:class="{ done: pasoMaxAlcanzado > 3 }")
              b-icon(v-if="pasoMaxAlcanzado > 3" icon="check-lg")
              span(v-else) 3
            .step-label Extensión de Garantía
            b-icon.step-toggle(:icon="pasoActivo === 3 ? 'chevron-up' : 'chevron-down'" v-if="pasoMaxAlcanzado >= 3")
          .step-body(v-show="pasoActivo === 3")
            b-overlay(:show="loadingExtensiones" rounded="sm")
              .text-muted.small.mb-3(v-if="!loadingExtensiones && !extensiones.length")
                | No hay extensiones disponibles para este modelo.

              .garantias-grid
                .garantia-card(
                  v-for="g in extensiones"
                  :key="g.id"
                  :class="{ selected: form.garantia_id === g.id }"
                  @click="seleccionarExtension(g.id)"
                )
                  svg.garantia-icon(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                    path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .garantia-nombre {{ g.nombre }}
                  .garantia-desc {{ g.descripcion }}
                  .garantia-precio(:class="{ 'precio-editado': esPrecioEditado(g.id) }")
                    | ${{ obtenerPrecioItem(g).toLocaleString('es-CL') }}
                    span.precio-original-tachado(v-if="esPrecioEditado(g.id)")
                      |  (Catálogo: ${{ Number(g.precio).toLocaleString('es-CL') }})
                  .link-editar-precio(@click.stop="abrirModalEditarPrecio(g)")
                    | Editar Precio
                  b-button.btn-garantia.mt-2(block size="sm")
                    | {{ form.garantia_id === g.id ? 'Seleccionado' : 'Agregar al Carrito' }}

              b-alert.mt-2(v-if="errors.garantia_id" show variant="danger") {{ errors.garantia_id }}

              .mt-3
                b-button.btn-sin-extension(
                  block
                  :disabled="!equipoReciente"
                  v-b-tooltip.hover="!equipoReciente && form.fecha_compra_equipo ? 'Solo disponible para equipos comprados hace 180 días o menos.' : ''"
                  @click="seleccionarSinExtension"
                )
                  | Ir a Protección Adicional sin Extensión de Garantía

            .d-flex.justify-content-end.mt-3
              b-button.btn-step-primary(
                :disabled="!form.garantia_id || submitting"
                @click="avanzarPaso3"
              )
                b-spinner(v-if="submitting && !equipoReciente" small class="mr-2")
                | {{ (!equipoReciente && submitting) ? 'Creando...' : (equipoReciente ? 'Siguiente Paso' : 'Finalizar OVG') }}

        //- ─── PASO 4: Protecciones ─────────────────────────────────────────────
        .step-card(v-if="mostrarPaso4")
          .step-header(@click="pasoMaxAlcanzado >= 4 && irAPaso(4)" :class="{ active: pasoActivo === 4, locked: pasoMaxAlcanzado < 4 }")
            .step-number 4
            .step-label Protección Adicional
            b-icon.step-toggle(:icon="pasoActivo === 4 ? 'chevron-up' : 'chevron-down'" v-if="pasoMaxAlcanzado >= 4")
          .step-body(v-show="pasoActivo === 4")
            b-overlay(:show="loadingProtecciones" rounded="sm")
              .text-muted.small.mb-3(v-if="!loadingProtecciones && !protecciones.length")
                | No hay protecciones disponibles para la extensión seleccionada.

              .garantias-grid
                .garantia-card(
                  v-for="p in protecciones"
                  :key="p.id"
                  :class="{ selected: form.proteccion_ids.includes(p.id) }"
                  @click="toggleProteccion(p.id)"
                )
                  svg.garantia-icon(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                    path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .garantia-nombre {{ p.nombre }}
                  .garantia-desc {{ p.descripcion }}
                  .garantia-precio(:class="{ 'precio-editado': esPrecioEditado(p.id) }")
                    | ${{ obtenerPrecioItem(p).toLocaleString('es-CL') }}
                    span.precio-original-tachado(v-if="esPrecioEditado(p.id)")
                      |  (Catálogo: ${{ Number(p.precio).toLocaleString('es-CL') }})
                  .link-editar-precio(@click.stop="abrirModalEditarPrecio(p)")
                    | Editar Precio
                  b-button.btn-garantia.mt-2(block size="sm")
                    | {{ form.proteccion_ids.includes(p.id) ? 'Seleccionado' : 'Agregar al Carrito' }}


              b-alert.mt-2(v-if="errors.garantias" show variant="danger") {{ errors.garantias }}

              b-button.btn-continuar-sin-proteccion.mt-3(
                block
                @click="continuarSinProteccion"
              ) Continuar sin Protección Adicional

              .d-flex.justify-content-end.mt-3
                b-button.btn-step-primary(
                  @click="avanzarPaso4"
                ) Siguiente Paso

        //- ─── PASO 5: Confirmación (Resumen Solicitud + Resumen Pago) ─────────
        .step-card(v-if="pasoActivo === 5")
          .step-body.resumen-solicitud-body
            .resumen-solicitud
              //- Título + descripción
              .resumen-solicitud-header
                h2.resumen-solicitud-title Resumen Solicitud
                p.resumen-solicitud-desc Revisa los detalles de tu garantía seleccionada y envía tu solicitud. Ventas revisará tu solicitud antes de aprobar la compra.

              //- Datos del cliente y equipo
              .resumen-solicitud-datos
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label Resumen Solicitud
                    span.resumen-dato-value.text-blue R.U.T
                    span.resumen-dato-valor {{ form.rut }}
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label Nombre
                    span.resumen-dato-valor {{ form.nombre }}
                  .resumen-dato
                    span.resumen-dato-label Correo Electrónico
                    span.resumen-dato-valor {{ form.correo }}
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label Apellido
                    span.resumen-dato-valor {{ form.apellido }}
                  .resumen-dato
                    span.resumen-dato-label Teléfono
                    span.resumen-dato-valor {{ form.telefono || '—' }}
                .resumen-dato-row
                  .resumen-dato.resumen-dato-wide
                    span.resumen-dato-label.text-blue N° De Serie Equipo ({{ cantidadSeries }} {{ cantidadSeries === 1 ? 'equipo' : 'equipos' }})
                    .resumen-series-list(v-if="!excelCargado")
                      b-badge.mr-1.mb-1(v-for="(s, sIdx) in form.numeros_serie" :key="sIdx" variant="light")
                        b-icon(icon="laptop" class="mr-1")
                        | {{ s }}
                    .resumen-excel-info.mt-1(v-else)
                      b-badge(variant="success")
                        b-icon(icon="file-earmark-excel-fill" class="mr-1")
                        | {{ archivoExcel ? archivoExcel.name : 'Excel' }} ({{ seriesExcel.length }} series)
                  .resumen-dato
                    span.resumen-dato-label Modelo del Equipo
                    span.resumen-dato-valor {{ modeloSeleccionado ? modeloSeleccionado.nombre : (form.modelo_nuevo_nombre || '—') }}

              //- Productos seleccionados
              .resumen-solicitud-productos
                .resumen-producto(v-if="extensionSeleccionada")
                  .resumen-producto-icon
                    svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                      path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .resumen-producto-info
                    span.resumen-producto-nombre {{ extensionSeleccionada.nombre }}
                    .d-flex.align-items-center.gap-2
                      span.resumen-producto-precio.text-blue ${{ obtenerPrecioItem(extensionSeleccionada).toLocaleString('es-CL') }}
                      span.badge.badge-warning.ml-2(v-if="esPrecioEditado(extensionSeleccionada.id)") Precio editado
                .resumen-producto(v-if="form.garantia_id === 'no_extension'")
                  .resumen-producto-icon
                    svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                      path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .resumen-producto-info
                    span.resumen-producto-nombre Sin extensión de tiempo
                    span.resumen-producto-precio $0
                .resumen-producto(v-for="p in proteccionesSeleccionadas" :key="p.id")
                  .resumen-producto-icon
                    svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                      path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .resumen-producto-info
                    span.resumen-producto-nombre {{ p.nombre }}
                    .d-flex.align-items-center.gap-2
                      span.resumen-producto-precio.text-blue ${{ obtenerPrecioItem(p).toLocaleString('es-CL') }}
                      span.badge.badge-warning.ml-2(v-if="esPrecioEditado(p.id)") Precio editado


      //- Columna derecha: Resumen Pago (solo paso 5)
      .resumen-column(v-if="pasoActivo === 5")
        .resumen-pago-card
          h3.resumen-pago-title Resumen Pago

          //- Cupón de descuento (SILL-1537)
          .cupon-seccion
            label.cupon-label Cupón de descuento (opcional)
            .input-group.input-group-cupon
              b-form-input.cupon-input(
                v-model="form.codigo_cupon"
                placeholder="Ingresa el código"
                :state="fieldState('codigo_cupon')"
                :disabled="cuponEstado === 'validando'"
                @keyup.enter="validarCupon"
              )
              .input-group-append
                b-button.btn-validar-cupon(
                  @click="validarCupon"
                  :disabled="!form.codigo_cupon.trim() || cuponEstado === 'validando'"
                )
                  b-spinner(v-if="cuponEstado === 'validando'" small variant="light")
                  b-icon(v-else icon="check2-circle" font-scale="1.2")
            .cupon-estado.mt-1(v-if="cuponEstado === 'valido'")
              b-icon(icon="check-circle-fill" variant="success")
              span.text-success.ml-1 Cupón aplicado: -{{ cuponDescuentoPorcentaje }}%
            .cupon-estado.mt-1(v-else-if="cuponEstado === 'invalido'")
              b-icon(icon="x-circle-fill" variant="danger")
              span.text-danger.ml-1 Cupón no válido o no disponible
            .cupon-estado.mt-1(v-else-if="cuponEstado === 'error'")
              span.text-danger.ml-1 {{ cuponError }}
            b-form-invalid-feedback(v-if="errors.codigo_cupon") {{ errors.codigo_cupon }}

          //- Totales
          .resumen-totales
            .resumen-total-row
              span.resumen-total-label Valor unitario (por serie):
              span.resumen-total-value ${{ totalEstimado.toLocaleString('es-CL') }}
            .resumen-total-row(v-if="cantidadSeries > 1")
              span.resumen-total-label Cantidad de series:
              span.resumen-total-value {{ cantidadSeries }}
            .resumen-total-row(v-if="descuentoCupon > 0")
              span.resumen-total-label Descuentos (por serie):
              span.resumen-total-value.text-success -${{ descuentoCupon.toLocaleString('es-CL') }}
            .resumen-total-row.resumen-total-final
              span.resumen-total-label-final Total ({{ cantidadSeries }} {{ cantidadSeries === 1 ? 'equipo' : 'equipos' }}):
              span.resumen-total-value-final ${{ totalOperacion.toLocaleString('es-CL') }}

          //- Error general
          b-alert(v-if="errorGeneral" show variant="danger" class="mt-3") {{ errorGeneral }}

          //- Banner y comentario si hay precio rebajado (SILL-1588)
          b-alert.mt-3.mb-2(v-if="hayPrecioRebajado" show variant="warning")
            .d-flex.align-items-start
              b-icon.mr-2.mt-1(icon="exclamation-triangle-fill")
              div
                strong Excepción requerida por precio menor:
                .small.mt-1 Al rebajar el precio de catálogo, esta OVG pasará al estado "En solicitud de excepción" y requerirá aprobación antes de poder realizar el cobro.
          b-form-group.mt-2(
            v-if="hayPrecioRebajado"
            label="Motivo del descuento / Comentario de excepción"
            label-class="samtek-label font-weight-bold"
          )
            b-form-textarea(
              v-model="comentarioExcepcion"
              placeholder="Ingresa el motivo del descuento aplicado..."
              rows="2"
              no-resize
            )

          //- Botones de acción
          .resumen-acciones
            b-button.btn-resumen-primary(
              :disabled="submitting || !puedeConfirmar"
              @click="handleSubmit"
            )
              b-spinner(v-if="submitting" small class="mr-2")
              | {{ submitting ? 'Creando...' : 'Finalizar OVG' }}
            b-button.btn-resumen-secondary(
              @click="$router.push('/garantias-center')"
            ) Volver atrás

          .text-muted.small.text-right.mt-1(v-if="!puedeConfirmar")
            b-icon(icon="exclamation-circle")
            |  Seleccioná al menos una extensión de tiempo o una protección adicional.

    //- ─── Modal: Editar Precio (SILL-1561) ──────────────────────────────────
    b-modal(
      v-model="showModalEditarPrecio"
      title="Editar Precio -"
      centered
      hide-footer
      @hidden="onModalEditarPrecioHidden"
      dialog-class="modal-editar-precio-dialog"
    )
      template(v-if="itemParaEditarPrecio")
        .item-card-resumen-modal.mb-3
          .item-card-resumen-nombre {{ itemParaEditarPrecio.nombre }}
          .item-card-resumen-desc.text-muted.small {{ itemParaEditarPrecio.descripcion }}
          .item-card-resumen-precio.mt-2 ${{ Number(itemParaEditarPrecio.precio).toLocaleString('es-CL') }}

        b-form-group(label="Ingresa Precio con Descuento" label-class="samtek-label font-weight-bold")
          b-form-input(
            v-model.number="precioEditadoTemp"
            type="number"
            min="0"
            :max="itemParaEditarPrecio.precio"
            placeholder="Ej: $40.000"
            :state="errorModalPrecio ? false : null"
            @keyup.enter="confirmarEditarPrecio"
          )
          b-form-invalid-feedback {{ errorModalPrecio }}

        .d-flex.justify-content-between.align-items-center.mt-4
          b-button.btn-modal-cancelar(
            variant="outline-secondary"
            @click="showModalEditarPrecio = false"
          ) Cancelar
          b-button.btn-modal-guardar(
            @click="confirmarEditarPrecio"
          ) Guardar



    //- ─── Modal: Crear Nuevo Modelo ─────────────────────────────────────────
    b-modal(
      v-model="showModalModeloNuevo"
      title="Crear nuevo modelo de equipo"
      centered
      hide-footer
      @hidden="onModalModeloHidden"
    )
      b-form-group(label="Nombre del Modelo*" label-class="samtek-label")
        b-form-input(
          v-model="modeloNuevoNombreTemp"
          placeholder=""
          :state="errorModalNombre ? false : null"
          @keyup.enter="confirmarModeloNuevo"
        )
        b-form-invalid-feedback {{ errorModalNombre }}
      .d-flex.justify-content-end.mt-4
        b-button.mr-2(variant="outline-secondary" @click="showModalModeloNuevo = false") Cancelar
        b-button.btn-confirmar-modelo(@click="confirmarModeloNuevo") Crear Modelo

    //- ─── Modal: Subir números de Excel masivo (SILL-1577 / SILL-1587) ────
    b-modal(
      v-model="showModalExcel"
      title="Subir números de Excel masivo"
      centered
      hide-footer
      dialog-class="modal-excel-series-dialog"
      no-close-on-backdrop
    )
      //- Banner informativo descarga plantilla
      .excel-modal-banner.mb-3
        .d-flex.align-items-center.justify-content-between
          .d-flex.align-items-center.mr-2
            b-icon.excel-info-icon(icon="info-circle-fill" variant="primary")
            span.excel-info-text.ml-2 Descarga la plantilla de ejemplo, ingresa los números de serie y luego sube el archivo aquí.
          b-button.btn-descargar-plantilla(
            variant="outline-primary"
            size="sm"
            :disabled="descargandoPlantilla"
            @click="descargarPlantilla"
          )
            b-spinner(v-if="descargandoPlantilla" small class="mr-1")
            b-icon(v-else icon="file-earmark-spreadsheet" class="mr-1")
            | Descargar Plantilla

      //- Sección Cargar Archivo
      .excel-modal-upload-section.mb-3
        label.samtek-label.font-weight-bold Cargar Archivo
        input(
          ref="excelFileInput"
          type="file"
          accept=".xlsx,.xls,.csv"
          style="display:none"
          @change="onExcelChange"
        )

        //- Dropzone cuando no hay archivo seleccionado
        .excel-dropzone(
          v-if="!archivoExcelTemp"
          @dragover.prevent="excelDragOver = true"
          @dragleave="excelDragOver = false"
          @drop.prevent="onExcelDrop"
          :class="{ 'is-dragover': excelDragOver }"
        )
          b-icon.upload-icon(icon="cloud-upload" font-scale="2.5" variant="primary")
          p.upload-text.mb-2 Arrastra y suelta tu archivo aquí.
          b-button.btn-seleccionar-archivo(@click="$refs.excelFileInput.click()") Seleccionar desde tu equipo
          small.text-muted.mt-2.d-block Formatos aceptados: .xlsx, .csv

        //- Archivo seleccionado
        .excel-archivo-cargado(v-else)
          .d-flex.align-items-center.justify-content-between.p-3.border.rounded
            .d-flex.align-items-center
              b-icon(icon="file-earmark-spreadsheet-fill" variant="primary" font-scale="2" class="mr-3")
              div
                .archivo-nombre.font-weight-bold {{ archivoExcelTemp.name }}
                .archivo-peso.text-muted.small {{ formatearTamanio(archivoExcelTemp.size) }}
            b-button(
              variant="link"
              class="text-danger p-0"
              @click="removerArchivoExcelTemp"
              title="Eliminar archivo"
            )
              b-icon(icon="trash-fill" font-scale="1.2")

      //- Error general o errores de fila
      b-alert.mb-3(v-if="errorGeneralExcel" show variant="danger")
        | {{ errorGeneralExcel }}

      .excel-errores-box.mb-3(v-if="erroresExcel.length")
        .text-danger.font-weight-bold.small.mb-1 Se encontraron {{ erroresExcel.length }} errores en el archivo:
        .errores-lista-scroll
          .error-fila-item(v-for="(err, eIdx) in erroresExcel" :key="eIdx")
            span.font-weight-bold Fila {{ err.fila }}
            span(v-if="err.serie")  ({{ err.serie }}): 
            span  {{ err.motivo }}

      //- Si la validación fue exitosa
      template(v-if="validacionExitosa")
        .excel-success-banner.mb-3
          b-icon(icon="check-circle-fill" variant="success" class="mr-2")
          strong Validación Exitosa:&nbsp;
          | El archivo cumple con los requisitos y está listo para seguir sin errores.

        .excel-preview-section.mb-3
          label.samtek-label.font-weight-bold Vista previa de Series ({{ seriesExcelPreview.length }})
          .series-preview-scroll
            .serie-preview-item(v-for="(s, sIdx) in seriesExcelPreview" :key="sIdx")
              span.font-weight-bold {{ sIdx + 1 }} - 
              span {{ s }}

        .excel-warning-banner.mb-3
          b-icon(icon="exclamation-triangle-fill" variant="warning" class="mr-2")
          strong Importante:&nbsp;
          | Al confirmar, el sistema usará las series de este archivo y bloqueará el ingreso manual en este paso.

      //- Si aún no se valida exitosamente
      template(v-else)
        .excel-warning-banner.mb-3
          b-icon(icon="exclamation-triangle-fill" variant="warning" class="mr-2")
          strong Importante:&nbsp;
          | Si tienes series ingresadas a mano, se descartarán para utilizar las del Excel.

      //- Footer del modal
      .d-flex.justify-content-end.align-items-center.mt-4
        b-button.mr-2(variant="outline-secondary" @click="cerrarModalExcel") Cancelar
        b-button.btn-validar-modal(
          v-if="!validacionExitosa"
          :disabled="!archivoExcelTemp || validandoExcel"
          @click="validarArchivoExcel"
        )
          b-spinner(v-if="validandoExcel" small class="mr-2")
          | Validar Archivo
        b-button.btn-validar-modal(
          v-else
          @click="confirmarExcel"
        ) Confirmar y Cerrar
</template>

<script>
import imageCompression from 'browser-image-compression'
import { mapActions } from 'vuex'

const HOY = new Date().toISOString().split('T')[0]
const DIAS_180 = 180

export default {
  name: 'OVGCreateView',

  data() {
    return {
      hoy: HOY,
      // Wizard
      pasoActivo: 1,
      pasoMaxAlcanzado: 1,
      // Formulario
      form: {
        nombre: '',
        apellido: '',
        correo: '',
        rut: '',
        telefono: '',
        numero_serie: '',
        numeros_serie: [''],
        fecha_compra_equipo: '',
        modelo_id: null,
        modelo_nuevo_nombre: '',
        garantia_id: null,
        proteccion_ids: [],
        codigo_cupon: '',
      },
      preciosEditados: {}, // { [producto_id]: precio_editado }
      comentarioExcepcion: '',
      // Modal editar precio (SILL-1561 / G3-25)
      showModalEditarPrecio: false,
      itemParaEditarPrecio: null,
      precioEditadoTemp: null,
      errorModalPrecio: '',
      boletaFile: null,
      boletaPreviewUrl: null,
      boletaDragOver: false,
      // Modelos
      modeloQuery: '',
      modeloResultados: [],
      modeloSeleccionado: null,
      modeloNuevo: false,
      loadingModelos: false,
      modeloSearchTimeout: null,
      // Segmentos (eliminado — el back lo asigna automáticamente)
      // Modal nuevo modelo
      showModalModeloNuevo: false,
      modeloNuevoNombreTemp: '',
      errorModalNombre: '',
      // Extensiones y protecciones
      extensiones: [],
      protecciones: [],
      loadingExtensiones: false,
      loadingProtecciones: false,
      // Cupón de descuento (SILL-1537)
      cuponEstado: '', // '', 'validando', 'valido', 'invalido', 'error'
      cuponDescuentoPorcentaje: 0,
      cuponDescuentoMonto: 0,
      cuponError: '',
      // Estado
      submitting: false,
      errors: {},
      errorGeneral: '',
      resultado: null,
      // Excel masivo de series (SILL-1587 / SILL-1577)
      showModalExcel: false,
      excelCargado: false,
      archivoExcel: null,
      archivoExcelTemp: null,
      seriesExcel: [],
      seriesExcelPreview: [],
      validandoExcel: false,
      descargandoPlantilla: false,
      validacionExitosa: false,
      erroresExcel: [],
      errorGeneralExcel: '',
      excelDragOver: false,
    }
  },

  computed: {
    tieneModelo() {
      return (
        !!this.form.modelo_id ||
        (this.modeloNuevo && !!this.form.modelo_nuevo_nombre.trim())
      )
    },

    boletaEsImagen() {
      if (!this.boletaFile) return false
      return this.boletaFile.type.startsWith('image/')
    },

    // OVG09: equipo reciente = comprado hace ≤ 180 días
    equipoReciente() {
      if (!this.form.fecha_compra_equipo) return false
      const fechaCompra = new Date(this.form.fecha_compra_equipo)
      const hoy = new Date()
      const diffDias = (hoy - fechaCompra) / (1000 * 60 * 60 * 24)
      return diffDias <= DIAS_180
    },

    extensionSeleccionada() {
      return (
        this.extensiones.find((e) => e.id === this.form.garantia_id) || null
      )
    },

    proteccionesSeleccionadas() {
      return this.protecciones.filter((p) =>
        this.form.proteccion_ids.includes(p.id)
      )
    },

    tieneExtension() {
      // 'no_extension' significa que el usuario eligió NO tener extensión de tiempo
      // por tanto no cuenta como "tener extensión" para confirmar sin protección
      return !!this.form.garantia_id && this.form.garantia_id !== 'no_extension'
    },

    tieneProteccion() {
      return this.form.proteccion_ids.length > 0
    },

    tieneSeleccion() {
      return this.tieneExtension || this.tieneProteccion
    },

    puedeConfirmar() {
      if (!this.tieneModelo) return false
      return this.tieneExtension || this.tieneProteccion
    },

    mostrarPaso4() {
      return this.pasoMaxAlcanzado >= 4 && this.equipoReciente
    },

    totalEstimado() {
      let total = 0
      if (this.extensionSeleccionada)
        total += this.obtenerPrecioItem(this.extensionSeleccionada)
      this.proteccionesSeleccionadas.forEach((p) => {
        total += this.obtenerPrecioItem(p)
      })
      return total
    },

    subtotalConCupon() {
      return this.totalEstimado - this.descuentoCupon
    },

    cantidadSeries() {
      if (this.excelCargado) {
        return this.seriesExcel.length
      }
      const seriesLimpias = (this.form.numeros_serie || []).filter(
        (s) => s && s.trim().length > 0
      )
      return seriesLimpias.length || 1
    },

    totalOperacion() {
      return this.subtotalConCupon * this.cantidadSeries
    },

    descuentoCupon() {
      if (this.cuponEstado !== 'valido' || !this.cuponDescuentoPorcentaje)
        return 0
      return Math.round(
        (this.totalEstimado * this.cuponDescuentoPorcentaje) / 100
      )
    },

    // Solo los precios editados de productos que siguen seleccionados: si el
    // usuario cambia de extensión o quita una protección, el precio editado
    // anterior no debe enviarse ni gatillar la excepción.
    preciosEditadosVigentes() {
      const seleccionados = [...this.form.proteccion_ids]
      if (this.form.garantia_id && this.form.garantia_id !== 'no_extension') {
        seleccionados.push(this.form.garantia_id)
      }
      return Object.fromEntries(
        Object.entries(this.preciosEditados || {}).filter(([id]) =>
          seleccionados.some((sel) => String(sel) === String(id))
        )
      )
    },

    hayPrecioRebajado() {
      const prods = [...(this.extensiones || []), ...(this.protecciones || [])]
      return Object.entries(this.preciosEditadosVigentes).some(
        ([id, editado]) => {
          const prod = prods.find((p) => String(p.id) === String(id))
          return prod && Number(editado) < Number(prod.precio)
        }
      )
    },
  },

  methods: {
    ...mapActions('OVGCenterStore', [
      'getModelos',
      'getGarantias',
      'crearOvgManual',
      'validarCuponGarantia',
      'validarSeriesExcel',
      'descargarPlantillaSeriesExcel',
    ]),

    // --- Navegación wizard ---
    irAPaso(n) {
      if (n <= this.pasoMaxAlcanzado || n === 5) this.pasoActivo = n
    },

    // --- Cupón de descuento (SILL-1537) ---
    async validarCupon() {
      const codigo = this.form.codigo_cupon.trim()
      if (!codigo) return

      this.errors = { ...this.errors, codigo_cupon: undefined }
      this.cuponEstado = 'validando'
      this.cuponError = ''

      try {
        const result = await this.validarCuponGarantia(codigo)
        this.cuponDescuentoPorcentaje = result.porcentaje_descuento
        this.cuponEstado = 'valido'
      } catch (err) {
        const status = err.response && err.response.status
        if (status === 404) {
          this.cuponEstado = 'invalido'
          this.cuponError = 'El código de descuento no es válido.'
        } else {
          this.cuponEstado = 'error'
          this.cuponError =
            '¡Lo sentimos! El código de descuento ya no está disponible.'
        }
        this.cuponDescuentoPorcentaje = 0
      }
    },

    // --- Métodos de series múltiples (G3-25) ---
    agregarSerie() {
      this.form.numeros_serie.push('')
    },

    removerSerie(index) {
      if (this.form.numeros_serie.length > 1) {
        this.form.numeros_serie.splice(index, 1)
        delete this.errors[`serie_${index}`]
      }
    },

    errorSerie(index) {
      if (!Object.keys(this.errors).length) return null
      return this.errors[`serie_${index}`] ? false : null
    },

    // --- Métodos de Excel de series (SILL-1577 / SILL-1587) ---
    abrirModalExcel() {
      this.archivoExcelTemp = this.archivoExcel || null
      this.validacionExitosa = this.excelCargado
      this.seriesExcelPreview = [...this.seriesExcel]
      this.erroresExcel = []
      this.errorGeneralExcel = ''
      this.showModalExcel = true
    },

    cerrarModalExcel() {
      this.showModalExcel = false
    },

    async descargarPlantilla() {
      this.descargandoPlantilla = true
      try {
        await this.descargarPlantillaSeriesExcel()
      } catch (e) {
        this.$bvToast.toast('Error al descargar la plantilla', {
          variant: 'danger',
        })
      } finally {
        this.descargandoPlantilla = false
      }
    },

    onExcelDrop(e) {
      this.excelDragOver = false
      const file = e.dataTransfer && e.dataTransfer.files[0]
      if (file) this.seleccionarArchivoExcel(file)
    },

    onExcelChange(e) {
      const file = e.target.files && e.target.files[0]
      if (file) this.seleccionarArchivoExcel(file)
    },

    seleccionarArchivoExcel(file) {
      const ext = file.name.split('.').pop().toLowerCase()
      if (!['xlsx', 'xls', 'csv'].includes(ext)) {
        this.errorGeneralExcel =
          'Formato no soportado. Solo se admiten archivos .xlsx o .csv'
        return
      }
      this.archivoExcelTemp = file
      this.validacionExitosa = false
      this.seriesExcelPreview = []
      this.erroresExcel = []
      this.errorGeneralExcel = ''
    },

    removerArchivoExcelTemp() {
      this.archivoExcelTemp = null
      this.validacionExitosa = false
      this.seriesExcelPreview = []
      this.erroresExcel = []
      this.errorGeneralExcel = ''
      if (this.$refs.excelFileInput) this.$refs.excelFileInput.value = ''
    },

    async validarArchivoExcel() {
      if (!this.archivoExcelTemp) return
      this.validandoExcel = true
      this.erroresExcel = []
      this.errorGeneralExcel = ''
      try {
        const res = await this.validarSeriesExcel(this.archivoExcelTemp)
        if (res.valido) {
          this.validacionExitosa = true
          this.seriesExcelPreview = res.series || []
          this.erroresExcel = []
        } else {
          this.validacionExitosa = false
          this.erroresExcel = res.errores || []
          this.errorGeneralExcel =
            res.error_general ||
            'Se encontraron errores en el archivo que impiden cargarlo.'
        }
      } catch (err) {
        const data = err.response && err.response.data
        this.validacionExitosa = false
        this.errorGeneralExcel =
          (data && (data.error || data.detail)) ||
          'Error al validar el archivo. Intenta nuevamente.'
      } finally {
        this.validandoExcel = false
      }
    },

    confirmarExcel() {
      this.archivoExcel = this.archivoExcelTemp
      this.seriesExcel = [...this.seriesExcelPreview]
      this.excelCargado = true
      this.showModalExcel = false
      this.$delete(this.errors, 'numero_serie')
    },

    quitarExcel() {
      this.excelCargado = false
      this.archivoExcel = null
      this.seriesExcel = []
      this.archivoExcelTemp = null
      this.seriesExcelPreview = []
      this.validacionExitosa = false
      this.erroresExcel = []
      this.errorGeneralExcel = ''
      this.form.numeros_serie = ['']
      if (this.$refs.excelFileInput) this.$refs.excelFileInput.value = ''
    },

    formatearTamanio(bytes) {
      if (!bytes) return '0 KB'
      const kb = Math.round(bytes / 1024)
      return `${kb} KB`
    },

    // --- Métodos de precio editable (SILL-1561 / G3-25) ---
    obtenerPrecioItem(item) {
      if (!item) return 0
      if (this.preciosEditados[item.id] !== undefined) {
        return Number(this.preciosEditados[item.id])
      }
      return Number(item.precio)
    },

    esPrecioEditado(itemId) {
      return this.preciosEditados[itemId] !== undefined
    },

    abrirModalEditarPrecio(item) {
      this.itemParaEditarPrecio = item
      this.precioEditadoTemp = this.obtenerPrecioItem(item)
      this.errorModalPrecio = ''
      this.showModalEditarPrecio = true
    },

    onModalEditarPrecioHidden() {
      this.itemParaEditarPrecio = null
      this.precioEditadoTemp = null
      this.errorModalPrecio = ''
    },

    confirmarEditarPrecio() {
      if (
        this.precioEditadoTemp === null ||
        this.precioEditadoTemp === undefined ||
        this.precioEditadoTemp === ''
      ) {
        this.errorModalPrecio = 'Ingrese un precio válido.'
        return
      }
      const nuevoPrecio = Number(this.precioEditadoTemp)
      if (Number.isNaN(nuevoPrecio) || nuevoPrecio < 0) {
        this.errorModalPrecio = 'El precio no puede ser negativo.'
        return
      }
      const precioCatalogo = Number(this.itemParaEditarPrecio.precio)
      if (nuevoPrecio > precioCatalogo) {
        this.errorModalPrecio = `El precio no puede superar el valor de catálogo ($${precioCatalogo.toLocaleString(
          'es-CL'
        )}).`
        return
      }
      // Si es igual al catálogo, eliminamos la edición para que quede como normal
      if (nuevoPrecio === precioCatalogo) {
        const copy = { ...this.preciosEditados }
        delete copy[this.itemParaEditarPrecio.id]
        this.preciosEditados = copy
      } else {
        this.$set(
          this.preciosEditados,
          this.itemParaEditarPrecio.id,
          Math.round(nuevoPrecio)
        )
      }
      this.showModalEditarPrecio = false
    },

    restaurarPrecioCatalogo() {
      if (this.itemParaEditarPrecio) {
        const copy = { ...this.preciosEditados }
        delete copy[this.itemParaEditarPrecio.id]
        this.preciosEditados = copy
      }
      this.showModalEditarPrecio = false
    },

    avanzarPaso1() {
      this.errors = {}
      if (!this.form.nombre.trim()) {
        this.errors.nombre = 'El nombre es obligatorio.'
        return
      }
      if (!this.form.apellido.trim()) {
        this.errors.apellido = 'El apellido es obligatorio.'
        return
      }
      if (!this.form.correo.trim()) {
        this.errors.correo = 'El correo es obligatorio.'
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.form.correo.trim())) {
        this.errors.correo = 'Ingresa un correo electrónico válido.'
        return
      }
      if (!this.form.rut.trim()) {
        this.errors.rut = 'El RUT es obligatorio.'
        return
      }
      if (this.pasoMaxAlcanzado < 2) this.pasoMaxAlcanzado = 2
      this.pasoActivo = 2
    },

    avanzarPaso2() {
      this.errors = {}

      if (this.excelCargado) {
        if (!this.seriesExcel || !this.seriesExcel.length) {
          this.errors.numero_serie = 'No hay series cargadas en el Excel.'
          return
        }
        ;[this.form.numero_serie] = this.seriesExcel
      } else {
        let hayErrorSerie = false

        if (!this.form.numeros_serie || !this.form.numeros_serie.length) {
          this.form.numeros_serie = ['']
        }

        const seriesLimpias = this.form.numeros_serie.map((s) =>
          (s || '').trim()
        )

        seriesLimpias.forEach((serie, idx) => {
          if (!serie) {
            this.errors[`serie_${idx}`] = 'El N° de serie es obligatorio.'
            hayErrorSerie = true
          } else if (serie.length !== 15) {
            this.errors[`serie_${idx}`] =
              'Debe tener exactamente 15 caracteres.'
            hayErrorSerie = true
          }
        })

        // Validar duplicados en la misma lista
        seriesLimpias.forEach((serie, idx) => {
          if (serie && seriesLimpias.indexOf(serie) !== idx) {
            this.errors[`serie_${idx}`] =
              'Número de serie repetido en la lista.'
            hayErrorSerie = true
          }
        })

        if (hayErrorSerie) {
          this.errors.numero_serie = 'Corregí los números de serie marcados.'
          return
        }

        // Sincronizar form.numero_serie para retrocompatibilidad
        ;[this.form.numero_serie] = seriesLimpias
      }

      if (!this.tieneModelo) {
        this.errors.modelo_id = 'Selecciona un modelo o indica uno nuevo.'
        return
      }
      if (!this.form.fecha_compra_equipo) {
        this.errors.fecha_compra_equipo = 'La fecha de compra es obligatoria.'
        return
      }
      if (!this.boletaFile) {
        this.errors.boleta_cliente = 'La boleta es obligatoria.'
        return
      }
      if (this.pasoMaxAlcanzado < 3) this.pasoMaxAlcanzado = 3
      this.pasoActivo = 3
    },

    avanzarPaso3() {
      this.errors = {}
      if (!this.form.garantia_id) {
        this.errors.garantia_id = 'Selecciona una extensión.'
        return
      }
      if (this.equipoReciente) {
        // Siempre refresca: si el usuario vuelve a paso 3 y cambia de extensión
        // (o venía de "Sin extensión"), paso 4 debe reflejar el nuevo tiempo
        // total elegido, no quedarse con la lista de la selección anterior.
        if (this.form.modelo_id) {
          this.fetchProtecciones(this.form.modelo_id)
        }
        if (this.pasoMaxAlcanzado < 4) this.pasoMaxAlcanzado = 4
        this.pasoActivo = 4
      } else {
        // Equipo > 180 días: no hay paso 4, ir directo a resumen
        if (this.pasoMaxAlcanzado < 5) this.pasoMaxAlcanzado = 5
        this.irAPaso(5)
      }
    },

    seleccionarSinExtension() {
      // Solo disponible si equipo reciente
      if (!this.equipoReciente) return
      this.form.garantia_id = 'no_extension'
      if (this.form.modelo_id) this.fetchProtecciones(this.form.modelo_id)
      if (this.pasoMaxAlcanzado < 4) this.pasoMaxAlcanzado = 4
      this.pasoActivo = 4
    },

    avanzarPaso4() {
      if (this.pasoMaxAlcanzado < 5) this.pasoMaxAlcanzado = 5
      this.irAPaso(5)
    },

    continuarSinProteccion() {
      // Limpia las protecciones seleccionadas y avanza al resumen
      this.form.proteccion_ids = []
      if (this.pasoMaxAlcanzado < 5) this.pasoMaxAlcanzado = 5
      this.irAPaso(5)
    },

    // --- Extensión ---
    seleccionarExtension(id) {
      this.form.garantia_id = id
    },

    // --- Protección ---
    toggleProteccion(id) {
      const idx = this.form.proteccion_ids.indexOf(id)
      if (idx === -1) {
        this.form.proteccion_ids.push(id)
      } else {
        this.form.proteccion_ids.splice(idx, 1)
      }
    },

    // --- Modelo ---
    onModeloSearch(q) {
      clearTimeout(this.modeloSearchTimeout)
      this.modeloSeleccionado = null
      this.form.modelo_id = null
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
      if (q.length < 2) {
        this.modeloResultados = []
        return
      }
      this.loadingModelos = true
      this.modeloSearchTimeout = setTimeout(async () => {
        try {
          const data = await this.getModelos({ q })
          this.modeloResultados = data.results || []
        } finally {
          this.loadingModelos = false
        }
      }, 350)
    },

    seleccionarModelo(modelo) {
      this.modeloSeleccionado = modelo
      this.form.modelo_id = modelo.id
      this.modeloResultados = []
      this.modeloQuery = modelo.nombre || String(modelo.id)
      this.fetchExtensiones(modelo.id)
    },

    limpiarModelo() {
      this.modeloSeleccionado = null
      this.form.modelo_id = null
      this.modeloQuery = ''
      this.modeloResultados = []
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
    },

    activarModeloNuevo() {
      this.modeloNuevoNombreTemp = ''
      this.errorModalNombre = ''
      this.showModalModeloNuevo = true
    },

    confirmarModeloNuevo() {
      this.errorModalNombre = ''
      if (!this.modeloNuevoNombreTemp.trim()) {
        this.errorModalNombre = 'El nombre del modelo es obligatorio.'
        return
      }
      this.form.modelo_nuevo_nombre = this.modeloNuevoNombreTemp.trim()
      this.form.modelo_id = null
      this.modeloSeleccionado = null
      this.modeloQuery = ''
      this.modeloResultados = []
      this.modeloNuevo = true
      this.showModalModeloNuevo = false
      // Cargar extensiones sin modelo_id
      this.onSegmentoChange()
    },

    onModalModeloHidden() {
      this.errorModalNombre = ''
    },

    cancelarModeloNuevo() {
      this.modeloNuevo = false
      this.form.modelo_nuevo_nombre = ''
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
    },

    // --- Segmento ---
    async onSegmentoChange() {
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
      this.loadingExtensiones = true
      try {
        this.extensiones = await this.getGarantias({ tipo: 'extension_tiempo' })
      } finally {
        this.loadingExtensiones = false
      }
    },

    // --- Fecha de compra ---
    onFechaCompraChange() {
      if (!this.equipoReciente) {
        this.form.proteccion_ids = []
        this.protecciones = []
        if (this.form.garantia_id === 'no_extension') {
          this.form.garantia_id = null
        }
        // Si ya estaba en paso 4, retroceder a paso 3
        if (this.pasoActivo === 4) {
          this.pasoActivo = 3
          this.pasoMaxAlcanzado = 3
        }
      } else if (this.form.modelo_id) {
        this.fetchProtecciones(this.form.modelo_id)
      }
    },

    // --- Extensiones ---
    async fetchExtensiones(modeloId) {
      this.loadingExtensiones = true
      this.extensiones = []
      this.form.garantia_id = null
      try {
        this.extensiones = await this.getGarantias({
          modeloId,
          tipo: 'extension_tiempo',
        })
      } finally {
        this.loadingExtensiones = false
      }
    },

    // --- Protecciones ---
    async fetchProtecciones(modeloId) {
      this.loadingProtecciones = true
      this.protecciones = []
      this.form.proteccion_ids = []
      try {
        // extensionId: el id real si hay extensión elegida, '' si el usuario
        // fue por "Sin extensión de tiempo". El backend calcula
        // anios_totales = base_warranty_years del modelo + esa extensión
        // (o solo la base si extensionId es '') — única fuente de verdad,
        // ya no se calcula en el front (ver GarantiasDisponiblesView).
        const extensionId = this.tieneExtension ? this.form.garantia_id : ''
        const danos = await this.getGarantias({
          modeloId,
          tipo: 'danos_accidentales',
          extensionId,
        })
        const onsite = await this.getGarantias({
          modeloId,
          tipo: 'atencion_onsite',
          extensionId,
        })
        // Deduplicar por id
        const todos = [...danos, ...onsite]
        const seen = new Set()
        this.protecciones = todos.filter((p) => {
          if (seen.has(p.id)) return false
          seen.add(p.id)
          return true
        })
      } finally {
        this.loadingProtecciones = false
      }
    },

    // --- Boleta ---
    onBoletaDrop(e) {
      this.boletaDragOver = false
      const file = e.dataTransfer && e.dataTransfer.files[0]
      if (!file) return
      this.boletaFile = file
      if (file.type.startsWith('image/')) {
        this.boletaPreviewUrl = URL.createObjectURL(file)
      } else {
        this.boletaPreviewUrl = null
      }
    },

    onBoletaChange(e) {
      const file = e.target.files[0]
      if (!file) {
        this.boletaFile = null
        this.boletaPreviewUrl = null
        return
      }
      this.boletaFile = file
      if (file.type.startsWith('image/')) {
        this.boletaPreviewUrl = URL.createObjectURL(file)
      } else {
        this.boletaPreviewUrl = null
      }
    },

    fieldState(field) {
      if (!Object.keys(this.errors).length) return null
      return this.errors[field] ? false : null
    },

    // --- Submit ---
    async handleSubmit() {
      this.errors = {}
      this.errorGeneral = ''
      this.resultado = null

      if (!this.puedeConfirmar) {
        this.errors.garantias =
          'Seleccioná al menos una extensión de tiempo o una protección adicional.'
        return
      }

      const fd = new FormData()
      fd.append('correo', this.form.correo)
      fd.append('nombre', this.form.nombre)
      fd.append('apellido', this.form.apellido)
      fd.append('rut', this.form.rut)
      if (this.form.telefono) fd.append('telefono', this.form.telefono)

      // SILL-1587: envío de archivo Excel o series manuales
      if (this.excelCargado && this.archivoExcel) {
        fd.append('archivo_series', this.archivoExcel, this.archivoExcel.name)
        if (this.seriesExcel.length > 0) {
          fd.append('numero_serie', this.seriesExcel[0])
        }
      } else {
        // G3-25: envío de series múltiples manuales
        const seriesLimpias = (this.form.numeros_serie || [])
          .map((s) => (s || '').trim())
          .filter((s) => s.length > 0)

        seriesLimpias.forEach((s) => fd.append('numeros_serie', s))
        // Campo de compatibilidad
        fd.append('numero_serie', seriesLimpias[0] || this.form.numero_serie)
      }

      fd.append('fecha_compra_equipo', this.form.fecha_compra_equipo)

      if (this.form.garantia_id && this.form.garantia_id !== 'no_extension') {
        fd.append('garantia_id', this.form.garantia_id)
      }
      this.form.proteccion_ids.forEach((id) => fd.append('proteccion_ids', id))

      // G3-25: precios editados compartidos
      if (Object.keys(this.preciosEditadosVigentes).length > 0) {
        fd.append(
          'precios_editados',
          JSON.stringify(this.preciosEditadosVigentes)
        )
      }

      let boletaParaEnviar = this.boletaFile
      if (this.boletaEsImagen) {
        boletaParaEnviar = await imageCompression(this.boletaFile, {
          maxSizeMB: 1,
          maxWidthOrHeight: 1280,
          useWebWorker: true,
          fileType: this.boletaFile.type,
        })
      }
      fd.append(
        'boleta_cliente',
        boletaParaEnviar,
        this.boletaFile.name || 'boleta.jpg'
      )

      if (this.form.modelo_id) {
        fd.append('modelo_id', this.form.modelo_id)
      } else {
        fd.append('modelo_nuevo_nombre', this.form.modelo_nuevo_nombre.trim())
      }

      // SILL-1537 — cupón de descuento (opcional)
      if (this.form.codigo_cupon.trim()) {
        fd.append('codigo_cupon', this.form.codigo_cupon.trim())
      }

      // Comentario de excepción si hay precio rebajado
      if (this.comentarioExcepcion && this.comentarioExcepcion.trim()) {
        fd.append('comentario_excepcion', this.comentarioExcepcion.trim())
      }

      this.submitting = true
      try {
        const res = await this.crearOvgManual(fd)
        this.resultado = res
        if (res.en_solicitud_excepcion) {
          this.$bvToast.toast(
            'La OVG quedó en solicitud de excepción por precio rebajado. No se generará link de pago hasta que sea aprobada.',
            {
              title: 'Solicitud de Excepción Generada',
              variant: 'warning',
              solid: true,
              autoHideDelay: 5000,
            }
          )
        }
        setTimeout(() => {
          this.$router.push(`/garantias-center/${res.ovg_id}`)
        }, 2000)
      } catch (err) {
        const status = err.response && err.response.status
        const data = (err.response && err.response.data) || {}

        if (status === 409) {
          this.errors.numero_serie =
            'Ya existe una OVG activa para este N° de serie.'
          // El error de serie se muestra en el paso 2: repetirlo arriba para verlo desde el resumen
          this.errorGeneral =
            data.error || 'Ya existe una OVG activa para este N° de serie.'
        } else if (status === 502) {
          this.errorGeneral =
            'Error al generar el link de pago (Getnet falló). Revisá los datos e intentá nuevamente.'
        } else if (status === 400) {
          if (typeof data === 'object') {
            const fieldMap = {
              garantia_id: 'garantia_id',
              proteccion_ids: 'garantias',
              fecha_compra_equipo: 'fecha_compra_equipo',
              modelo_id: 'modelo_id',
              modelo_nuevo_nombre: 'modelo_nuevo_nombre',
              numero_serie: 'numero_serie',
              correo: 'correo',
              nombre: 'nombre',
              apellido: 'apellido',
              rut: 'rut',
              telefono: 'telefono',
              boleta_cliente: 'boleta_cliente',
              codigo_cupon: 'codigo_cupon',
            }
            Object.entries(fieldMap).forEach(([apiKey, formKey]) => {
              if (data[apiKey]) {
                this.errors[formKey] = Array.isArray(data[apiKey])
                  ? data[apiKey][0]
                  : data[apiKey]
              }
            })
            // Errores sin campo propio en el formulario: mostrarlos como generales
            const errorSinCampo = [
              'precios_editados',
              'numeros_serie',
              'archivo_series',
            ]
              .map((key) => data[key])
              .find(Boolean)
            if (data.non_field_errors) {
              this.errorGeneral = Array.isArray(data.non_field_errors)
                ? data.non_field_errors[0]
                : data.non_field_errors
            } else if (errorSinCampo) {
              this.errorGeneral = Array.isArray(errorSinCampo)
                ? errorSinCampo[0]
                : errorSinCampo
            } else if (!Object.keys(this.errors).length) {
              this.errorGeneral =
                data.error ||
                'Error de validación. Revisá los datos ingresados.'
            }
          } else {
            this.errorGeneral =
              'Error de validación. Revisá los datos ingresados.'
          }
        } else {
          this.errorGeneral = 'Error inesperado. Intentá nuevamente.'
        }
      } finally {
        this.submitting = false
      }
    },
  },

  mounted() {},
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.ovg-create-view {
  background-color: #f5f6fa;
  min-height: 100vh;
  padding-bottom: 60px;
}

.container-create {
  padding: 20px;
  max-width: 960px;
  margin: 0 auto;
}

.header-ovg {
  display: flex;
  align-items: center;
  height: 4rem;
  padding: 0 20px;

  .title-section {
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;

    .back-arrow {
      color: $samtek-yellow;
      font-size: 32px;
    }

    .title {
      margin: 0;
      font-weight: bold;
      color: $samtek-black;
    }
  }
}

.breadcrumbs-ovg {
  margin-bottom: 25px;
  font-size: 14px;
  padding: 0 20px;
}

// ── Wizard steps ────────────────────────────────────────────────────────────
.step-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  overflow: hidden;
}

.step-header {
  display: flex;
  align-items: center;
  padding: 18px 24px;
  cursor: pointer;
  user-select: none;
  gap: 14px;

  &.locked {
    cursor: default;
    opacity: 0.5;
  }
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $samtek-yellow;
  color: $samtek-black;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.done {
    background: #28a745;
    color: #fff;
  }
}

.step-label {
  font-weight: 700;
  font-size: 16px;
  color: #23201c;
  flex: 1;
}

.step-toggle {
  color: #888;
}

.step-body {
  padding: 24px;
}

// ── Modelo con botón ────────────────────────────────────────────────────────
.modelo-grupo {
  margin-top: 12px;

  label {
    display: block;
    margin-bottom: 6px;
  }
}

.btn-crear-modelo {
  white-space: nowrap;
  height: 38px;
  align-self: flex-end;
  background-color: #f5f6fa;
  border-color: #ced4da;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 0 20px;
}

// ── Boleta drag-and-drop ─────────────────────────────────────────────────────
.boleta-dropzone {
  border: 1px dashed #525252;
  border-radius: 5px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: background 0.2s, border-color 0.2s;
  cursor: default;

  &.is-dragover {
    background-color: #fffbea;
    border-color: $samtek-yellow;
  }
}

.boleta-upload-icon {
  color: #1a73e8;
  margin-bottom: 8px;
}

.boleta-upload-text {
  color: #525252;
  font-size: 15px;
}

.btn-seleccionar-boleta {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 6px 20px;

  &:hover {
    background-color: darken($samtek-yellow, 8%);
    border-color: darken($samtek-yellow, 8%);
    color: #23201c;
  }
}

// ── Modelo ─────────────────────────────────────────────────────────────────
.modelo-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modelo-resultados {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-top: 4px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.modelo-item {
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &.selected {
    background-color: #f8f9fa;
    font-weight: 600;
  }
}

.modelo-seleccionado {
  margin-top: 8px;
}

.otro-modelo-box {
  background: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
}

// ── Cards de garantía (extensiones y protecciones) ──────────────────────────
.garantias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 8px;
}

.garantia-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  text-align: left;
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: $samtek-yellow;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &.selected {
    border-color: $samtek-yellow;
    background: #fffbea;

    .btn-garantia {
      background-color: darken($samtek-yellow, 6%);
      border-color: darken($samtek-yellow, 6%);
    }
  }
}

.garantia-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 10px;
}

.garantia-nombre {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 6px;
  color: #23201c;
}

.garantia-desc {
  font-size: 13px;
  color: #525252;
  margin-bottom: 10px;
  flex: 1;
}

.garantia-precio {
  font-weight: 700;
  font-size: 18px;
  color: #23201c;
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;

  &.precio-editado {
    color: #d97706; /* Color ámbar/naranja para destacar valor editado */
  }
}

.precio-original-tachado {
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
  text-decoration: line-through;
}

.link-editar-precio {
  font-size: 12px;
  color: #2563eb;
  cursor: pointer;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-decoration: underline;

  &:hover {
    color: darken(#2563eb, 15%);
  }
}

.seccion-subtitulo {
  font-size: 16px;
  font-weight: 700;
  color: #23201c;
  margin-bottom: 16px;
}

.serie-fila {
  margin-bottom: 12px;
}

.serie-input-box {
  gap: 8px;
}

.serie-input-field {
  max-width: 380px;
}

.btn-eliminar-serie-icon {
  padding: 0 4px;
  color: #dc3545;
  font-size: 18px;

  &:hover {
    color: darken(#dc3545, 12%);
  }
}

.btn-add-serie-mockup {
  color: #1d4ed8;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: darken(#1d4ed8, 10%);
  }
}

.item-card-resumen-modal {
  border: 1px solid #444444;
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
}

.item-card-resumen-nombre {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
}

.item-card-resumen-precio {
  font-size: 18px;
  font-weight: 700;
  color: #203859;
}

.btn-modal-cancelar {
  border-radius: 8px;
  padding: 8px 24px;
  font-weight: 500;
  color: #525252;
  border-color: #d1d5db;
}

.btn-modal-guardar {
  background-color: #fece2f;
  border-color: #fece2f;
  color: #23201c;
  border-radius: 8px;
  padding: 8px 24px;
  font-weight: 500;

  &:hover,
  &:focus,
  &:active {
    background-color: darken(#fece2f, 8%) !important;
    border-color: darken(#fece2f, 8%) !important;
    color: #23201c !important;
  }
}

.resumen-series-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.btn-garantia {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;

  &:hover,
  &:focus,
  &:active {
    background-color: darken($samtek-yellow, 8%) !important;
    border-color: darken($samtek-yellow, 8%) !important;
    color: #23201c !important;
    box-shadow: none !important;
  }
}

.btn-step-primary {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 8px 24px;

  &:hover,
  &:focus,
  &:active {
    background-color: darken($samtek-yellow, 8%) !important;
    border-color: darken($samtek-yellow, 8%) !important;
    color: #23201c !important;
    box-shadow: none !important;
  }

  &:disabled {
    background-color: $samtek-yellow;
    border-color: $samtek-yellow;
    opacity: 0.5;
  }
}

// ── Layout 2 columnas (Figma SILL-1536) ──────────────────────────────────────
.create-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.wizard-column {
  flex: 1;
  min-width: 0;
  max-width: 860px;
  margin: 0 auto;
}

.resumen-column {
  width: 320px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;
}

@media (max-width: 1024px) {
  .create-layout {
    flex-direction: column;
  }
  .wizard-column {
    max-width: 100%;
  }
  .resumen-column {
    width: 100%;
    position: static;
  }
}

// ── Resumen Pago Card ──────────────────────────────────────────────────────
.resumen-pago-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.resumen-pago-title {
  font-size: 20px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

// ── Cupón de descuento (SILL-1537) ──────────────────────────────────────────
.cupon-seccion {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cupon-label {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.input-group-cupon {
  .form-control {
    border-radius: 6px 0 0 6px;
    border-color: #d1d5db;
    font-size: 14px;
    height: 40px;

    &:focus {
      border-color: #1d4ed8;
      box-shadow: 0 0 0 0.15rem rgba(29, 78, 216, 0.25);
    }
  }
}

.btn-validar-cupon {
  background-color: #203859;
  border-color: #203859;
  color: #ffffff;
  border-radius: 0 6px 6px 0;
  padding: 0 14px;
  font-weight: 500;
  height: 40px;

  &:hover,
  &:focus,
  &:active {
    background-color: darken(#203859, 8%) !important;
    border-color: darken(#203859, 8%) !important;
    color: #ffffff !important;
  }

  &:disabled {
    background-color: #203859;
    border-color: #203859;
    opacity: 0.5;
  }
}

.cupon-estado {
  font-size: 13px;
  display: flex;
  align-items: center;
}

// ── Totales ────────────────────────────────────────────────────────────────
.resumen-totales {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.resumen-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resumen-total-label {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
}

.resumen-total-value {
  font-size: 14px;
  font-weight: 600;
  color: #23201c;
}

.resumen-total-final {
  border-top: 1px solid #e5e7eb;
  padding-top: 10px;
  margin-top: 4px;
}

.resumen-total-label-final {
  font-size: 18px;
  font-weight: 700;
  color: #203859;
}

.resumen-total-value-final {
  font-size: 22px;
  font-weight: 700;
  color: #203859;
}

// ── Botones resumen ────────────────────────────────────────────────────────
.resumen-acciones {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-resumen-primary {
  background-color: #fece2f;
  border-color: #fece2f;
  color: #23201c;
  font-weight: 500;
  font-size: 15px;
  border-radius: 8px;
  height: 45px;
  padding: 10px 20px;
  width: 100%;

  &:hover,
  &:focus,
  &:active {
    background-color: darken(#fece2f, 8%) !important;
    border-color: darken(#fece2f, 8%) !important;
    color: #23201c !important;
  }

  &:disabled {
    background-color: #fece2f;
    border-color: #fece2f;
    opacity: 0.5;
  }
}

.btn-resumen-secondary {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #23201c;
  font-weight: 500;
  font-size: 15px;
  border-radius: 8px;
  height: 45px;
  padding: 10px 20px;
  width: 100%;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    background-color: #f5f6fa !important;
    border-color: #f5f6fa !important;
    color: #23201c !important;
  }
}

.boleta-img-preview {
  max-width: 100%;
  max-height: 220px;
  border-radius: 8px;
  object-fit: contain;
}

.btn-cambiar-boleta {
  color: #525252;
  font-size: 13px;
}

.btn-confirmar-modelo {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 6px 20px;

  &:hover {
    background-color: darken($samtek-yellow, 8%);
    border-color: darken($samtek-yellow, 8%);
    color: #23201c;
  }
}

// ── Labels ──────────────────────────────────────────────────────────────────
::v-deep .samtek-label {
  font-weight: 700;
}

// ── Botones ─────────────────────────────────────────────────────────────────
.btn-crear {
  min-width: 160px;
}

.btn-sin-extension,
.btn-continuar-sin-proteccion {
  background-color: #fff;
  border: 1px solid #ced4da;
  color: #23201c;
  font-weight: 400;
  border-radius: 8px;
  margin-top: 8px;

  &:hover:not(:disabled) {
    border-color: $samtek-yellow;
    color: #23201c;
    background-color: #fff;
  }

  &:disabled {
    opacity: 0.45;
  }
}

// ── Resumen de la Solicitud (Paso 5) ────────────────────────────────────────
.resumen-solicitud-body {
  padding: 20px;
}

.resumen-solicitud {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.resumen-solicitud-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.resumen-solicitud-title {
  font-size: 28px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
}

.resumen-solicitud-desc {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
  margin: 0;
  max-width: 660px;
}

// ── Datos del cliente y equipo ─────────────────────────────────────────────
.resumen-solicitud-datos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resumen-dato-row {
  display: flex;
  gap: 24px;
}

.resumen-dato {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 225px;
}

.resumen-dato-wide {
  flex: 1;
}

.resumen-dato-label {
  font-size: 15px;
  font-weight: 700;
  color: #525252;
}

.resumen-dato-label.text-blue {
  color: #1d4ed8;
}

.resumen-dato-value {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
}

.resumen-dato-valor {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
}

// ── Productos seleccionados ────────────────────────────────────────────────
.resumen-solicitud-productos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resumen-producto {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1px solid #444444;
  border-radius: 4px;
  background: #ffffff;
  height: 80px;
}

.resumen-producto-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #525252;
}

.resumen-producto-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.resumen-producto-nombre {
  font-size: 15px;
  font-weight: 700;
  color: #525252;
}

.resumen-producto-precio {
  font-size: 20px;
  font-weight: 700;
  color: #203859;
}

.text-blue {
  color: #1d4ed8 !important;
}

@media (max-width: 768px) {
  .container-create {
    padding: 12px;
  }
  .garantias-grid {
    grid-template-columns: 1fr 1fr;
  }
}

// ─── Estilos Excel masivo (SILL-1577 / SILL-1587) ──────────────────────────
.btn-subir-excel-series {
  border-color: #0b5fff;
  color: #0b5fff;
  background-color: #fff;
  font-weight: 600;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  &:hover {
    background-color: #eef4ff;
    color: #0b5fff;
    border-color: #0b5fff;
  }
}

.excel-cargado-box {
  border-radius: 8px;
  background-color: #f8fafc;
}

.excel-modal-banner {
  background-color: #eef4ff;
  border: 1px solid #c7dcfe;
  border-radius: 8px;
  padding: 14px 16px;
}

.excel-info-icon {
  font-size: 20px;
  color: #0b5fff;
  flex-shrink: 0;
}

.excel-info-text {
  font-size: 13px;
  color: #1e3a8a;
  line-height: 1.4;
}

.btn-descargar-plantilla {
  white-space: nowrap;
  font-weight: 600;
  font-size: 12px;
  border-color: #0b5fff;
  color: #0b5fff;
  background: #fff;
  border-radius: 6px;
  padding: 6px 12px;
  &:hover {
    background: #e0ecff;
    color: #0b5fff;
    border-color: #0b5fff;
  }
}

.excel-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 28px 16px;
  text-align: center;
  background-color: #ffffff;
  transition: all 0.2s;
  cursor: pointer;

  &.is-dragover {
    background-color: #eff6ff;
    border-color: #0b5fff;
  }

  .upload-icon {
    color: #0b5fff;
    margin-bottom: 8px;
  }

  .upload-text {
    font-size: 14px;
    color: #475569;
    font-weight: 500;
  }

  .btn-seleccionar-archivo {
    background-color: #f5b301;
    border-color: #f5b301;
    color: #1a1a1a;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 18px;
    border-radius: 6px;
    &:hover {
      background-color: #dca000;
      border-color: #dca000;
    }
  }
}

.excel-archivo-cargado {
  background: #fff;
  .archivo-nombre {
    font-size: 14px;
    color: #1e293b;
  }
  .archivo-peso {
    font-size: 12px;
    color: #64748b;
  }
}

.excel-warning-banner {
  background-color: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 13px;
  color: #92400e;
  line-height: 1.4;
}

.excel-success-banner {
  background-color: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 13px;
  color: #065f46;
  line-height: 1.4;
}

.excel-errores-box {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 12px;
}

.errores-lista-scroll {
  max-height: 150px;
  overflow-y: auto;
  .error-fila-item {
    font-size: 12px;
    color: #991b1b;
    padding: 3px 0;
    border-bottom: 1px solid #fee2e2;
    &:last-child {
      border-bottom: none;
    }
  }
}

.series-preview-scroll {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: #f8fafc;
  padding: 8px;
}

.serie-preview-item {
  padding: 6px 12px;
  font-size: 13px;
  font-family: monospace;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  margin-bottom: 4px;
  color: #1e293b;
  &:last-child {
    margin-bottom: 0;
  }
}

.btn-validar-modal {
  background-color: #f5b301;
  border-color: #f5b301;
  color: #1a1a1a;
  font-weight: 700;
  font-size: 14px;
  padding: 9px 22px;
  border-radius: 6px;
  &:hover:not(:disabled) {
    background-color: #dca000;
    border-color: #dca000;
  }
}
</style>
